<template>
  <Section id="create-your-own" class="create-your-own">
    <div class="componata-container --is-narrow">
      <div class="grid">
        <div class="col-6_sm-12">
          <SectionHeader textAlign="left">
            <template v-slot:title>Erstellen Sie Ihr eigenes persönliches Präsent</template>

            <template v-slot:description>
              <p>Persönlicher geht es kaum: Legen Sie jede Delikatesse selber fest. Wir erstellen Ihre individuelle Präsentbox komplett nach Ihren Wünschen!</p>

              <Button appearance="primary" size="large" :href="'/praesente' + cLink('/zusammenstellen')" style="display: inline-block;">Jetzt anfangen!</Button>
              <span v-if="$store.getters.isB2b" class="create-your-own__or-cta">oder <Button @click="scrollTo('contact');" size="large" style="display: inline-block;">Kontakt aufnehmen</Button></span>
            </template>
          </SectionHeader>
        </div>

        <div class="col-6_sm-12">
          <div class="create-your-own__carousel --is-first">
            <ul class="create-your-own__products">
              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    class="create-your-own__product-photo"
                    :src="`${require('@/assets/images/landing-page/dummyprod1@2x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Citron und Gingembre in Metalldose, 250ml, von A I'Olivier"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/fr.svg" class="create-your-own__product-flag" alt="Frankreich">
              </li>

              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="100">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod2@2x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Spicy Chai Latte, 250g, von Barú"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/nl.svg" class="create-your-own__product-flag" alt="Niederlande">
              </li>

              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="200">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod3@2x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Schokolade 63% Cashew and Sea Salt von Menakao"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/mg.svg" class="create-your-own__product-flag" alt="Madagascar">
              </li>

              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="300">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod4@2x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Schokolade Raspberry and Blueberry Dark Milk von Malmö"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/se.svg" class="create-your-own__product-flag" alt="Schweden">
              </li>

              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="400">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod5@2x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Tonnarelli Peperoncino, 500g von Rustichella D'Abruzzo"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/it.svg" class="create-your-own__product-flag" alt="Italien">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="componata-container create-your-own__objects-container">
      <div class="grid-bottom">
        <div class="col-6_lg-6_sm-12">
          <div class="create-your-own__carousel --is-second">
            <ul class="create-your-own__products">
              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="500">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod6@2x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="3 - RED, 150g, von Lakrids By Bülow"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/dk.svg" class="create-your-own__product-flag" alt="Dänemark">
              </li>

              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="400">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod7@2x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Bouvet 1851 Blanc, 375ml, von Bouvet Ladubay"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/fr.svg" class="create-your-own__product-flag" alt="Frankreich">
              </li>

              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="300">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod8@2x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="San Marzano in Dose, 400g, von Il pomodoro più buono"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/it.svg" class="create-your-own__product-flag" alt="Italien">
              </li>

              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="200">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod9@1x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Dunkle Schokolade 60% Kakao, Noir, 45g, von von Café-Tasse"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/be.svg" class="create-your-own__product-flag" alt="Belgien">
              </li>

              <li class="create-your-own__product --is-selected" data-aos="zoom-out" data-aos-duration="300" data-aos-delay="100">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod10@1x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Flor de Sal Meersalz, Natural, 150g von von Flor de Sal d'Es Trenc"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/es.svg" class="create-your-own__product-flag" alt="Spanien">
              </li>

              <li class="create-your-own__product" data-aos="zoom-out" data-aos-duration="300">
                <div class="create-your-own__product-photo-wrapper">
                  <img
                    :src="`${require('@/assets/images/landing-page/dummyprod11@1x.png')}?format=${webPFormat('png')}&quality=80&compression=4`"
                    alt="Wheat Flatbreads, Oliven und Knoblauch, 130g, von Cartwright und Butler"
                    class="create-your-own__product-photo"
                    loading="lazy"
                  >
                </div>

                <img src="@/assets/images/landing-page/flags/gb.svg" class="create-your-own__product-flag" alt="Großbritannien">
              </li>
            </ul>
          </div>
        </div>

        <div class="col-6_lg-6_sm-12">
          <img
            class="create-your-own__empty-box"
            :srcset="`
              ${require('@/assets/images/landing-page/box-empty-s-frontal@2x.png')}?format=${webPFormat('png')}&width=1400&quality=80&compression=4 1400w,
              ${require('@/assets/images/landing-page/box-empty-s-frontal@2x.png')}?format=${webPFormat('png')}&width=700&quality=80&compression=4 700w
            `"
            sizes="
              (max-width: 36em) 90vw,
              43em
            "
            :src="`${require('@/assets/images/landing-page/box-empty-s-frontal@2x.png')}?format=${webPFormat('png')}&width=700&quality=80&compression=4`"
            alt="Empty Präsent"
            loading="lazy"
          >

          <div
            class="create-your-own__drag"
            data-aos="fade-right" data-aos-duration="900" data-aos-delay="900"
          >
            <img
              class="create-your-own__drag-photo"
              :srcset="`
                ${require('@/assets/images/landing-page/dummyprod-in-motion@2x.png')}?format=${webPFormat('png')}&width=604&quality=80&compression=4 604w,
                ${require('@/assets/images/landing-page/dummyprod-in-motion@2x.png')}?format=${webPFormat('png')}&width=303&quality=80&compression=4 303w
              `"
              sizes="
                (max-width: 36em) 33vw,
                16em
              "
              :src="`${require('@/assets/images/landing-page/dummyprod-in-motion@2x.png')}?format=${webPFormat('png')}&width=303&quality=80&compression=4`"
              alt="Roquefort"
              loading="lazy"
            >

            <img
              class="create-your-own__drag-cursor"
              src="@/assets/images/landing-page/cursor-big.svg"
            >
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';
import { logicMixin } from '@/mixins/LogicMixin';
import { helperMixin } from '@/mixins/HelperMixin';

import Section from '@/components/PresentPage/Section';
import SectionHeader from '@/components/PresentPage/SectionHeader';
import Button from '@/components/Common/Button';

export default {
  name: 'CreateYourOwn',
  mixins: [logicMixin, UiMixin, helperMixin],
  components: {
    Section,
    SectionHeader,
    Button
  }
};
</script>

<style lang="scss" scoped>
/**
 * CreateYourOwn
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Promo content for Create Your Own Present aka Level 3
 * @since 2021-01-15
**/

$component: 'create-your-own';

.#{$component} {
  position: relative;
  overflow: hidden;
  // min-height: 100vh;
  background:
    url('~@/assets/images/landing-page/bgr-blocks.svg') center 30% no-repeat,
    linear-gradient(to bottom, #F3FFE8 50%, desaturate(darken(#FFFFF1, 10%), 50%));
  background-size: 130%;
  z-index: 0;

  // LP Section Heading overwritings
  .landing-page__section-heading {
    margin-bottom: 0;
    text-align: left;
  }

  // Special container
  &__objects-container {
    position: relative;
    z-index: 0;
  }

  // for B2B
  &__or-cta {
    display: inline-block;
    @include margin-left(map-get($spacers, 3));

    ::v-deep .btn:first-child {
      @include margin-left(map-get($spacers, 3));
    }
  }

  // Carousel
  &__carousel {
    &.--is-first {
    }

    &.--is-second {
      margin-left: -220px;
    }
  }

  // Products
  &__products {
    @include unlist;
    display: flex;
  }

  &__product {
    text-align: center;
    z-index: -1 !important;

    & + & {
      @include margin-left(map-get($spacers, 3));
    }

    &.--is-selected {
      .#{$component}__product-photo-wrapper {
        border-color: green;
      }

      .#{$component}__product-photo {
        opacity: 0.5;
      }
    }
  }

  &__product-photo-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 146px;
    height: 146px;
    @include padding(map-get($spacers, 5));
    border: 3px dashed transparent;
    border-radius: $border-radius-lg * 2;
  }

  &__product-photo {
    width: auto;
    max-width: unset;
    height: 110px;
  }

  &__product-flag {
    display: inline-block;
    width: 32px;
    height: 32px;
    border: 3px solid white;
    border-radius: 50%;
    @include margin-top(map-get($spacers, 4));
  }

  // Empty box on the side
  &__empty-box {
    display: block;
    width: 700px;
    max-width: 700px;
    height: auto;
    margin-top: -50px;
    margin-bottom: -300px;
    margin-left: 200px;
    z-index: 1;
    @include imageRendering;
  }

  &__drag {
    position: absolute;
    bottom: 0;
    right: 300px;
    width: 264px;
  }

  &__drag-photo {
    width: 100%;
    filter: drop-shadow(-5px 5px 5px rgba(black, 0.2));
    @include imageRendering;
  }

  &__drag-cursor {
    position: absolute;
    bottom: -20%;
    right: -20%;
    width: 50%;
    height: auto;
    filter: drop-shadow(-5px 5px 5px rgba(black, 0.5));
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
    &__empty-box {
      margin-left: 80px;
    }

    &__drag {
      right: 140px;
    }
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &__carousel.--is-first {
      display: none;
    }

    &__carousel.--is-second {
      @include margin-top(map-get($spacers, 4));
      margin-left: auto;
      margin-right: auto;
    }

    &__products {
      justify-content: center;
    }

    // For this breakpoint, let's make the objects a bit smaller
    &__product-photo-wrapper {
      width: 96px;
      height: 96px;
    }

    &__product-photo {
      height: 60px;
    }

    &__product-flag {
      width: 20px;
      height: 20px;
      @include margin-top(map-get($spacers, 2));
    }

    // Box
    &__empty-box {
      width: 80%;
      margin-left: auto;
      margin-right: auto;
      margin-bottom: -240px;
      @include margin-top(map-get($spacers, 6) * 2);
    }

    &__drag {
      width: 30%;
      top: 30%;
      bottom: unset;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    // Box
    &__empty-box {
      width: 90%;
    }

    &__drag {
      top: 50%;
    }
  }
}
</style>
